import { render, staticRenderFns } from "./p_company010.vue?vue&type=template&id=5719ee4a&scoped=true&"
import script from "./p_company010.vue?vue&type=script&lang=js&"
export * from "./p_company010.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5719ee4a",
  null
  
)

export default component.exports